import { render } from "./CounterInput.vue?vue&type=template&id=fcaf5482&scoped=true"
import script from "./CounterInput.vue?vue&type=script&lang=js"
export * from "./CounterInput.vue?vue&type=script&lang=js"

import "./CounterInput.vue?vue&type=style&index=0&id=fcaf5482&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcaf5482"]])

export default __exports__